<template lang="pug">
div.slideshow
    image-swipe(
        ref="swipe"
        v-on:next-page="$emit('next-page')"
        v-on:prev-page="$emit('prev-page')"
        v-on:close="$emit('close')")

</template>

<script>
import EntityMixin from '@/components/Base/EntityMixin';

/**
 * Wrapper for ImageSwipe (which is a wrapper for PhotoSwipe)
 */
export default {
    name: 'artwork-slideshow',

    props: {
        items: {    type: Array[Object] },
        index: {    type: Number, default: 0 },
        active: {   type: Boolean }
    },

    mixins: [ EntityMixin ],

    components: {
        ImageSwipe: () => import('@/components/ImageSwipe.vue')
    },

    data: function () {
        return {};
    },

    mounted: function () {
        this.update();
    },

    watch: {
        active: function () {
            this.update();
        },

        items: function () {
            this.update();
        }
    },

    methods: {
        openSwipe: function () {
            this.$refs.swipe && this.$refs.swipe.open(this.index, this.getImages());
        },

        closeSwipe: function () {
            this.$refs.swipe && this.$refs.swipe.close();
        },

        /**
         * Get array of image urls for PhotoSwipe.
         */
        getImages: function () {
            return _.compact(_.map(this.items, (item) => {

                const imageInfo = this.$helpers.getImageInfo(item, true); // FIXME: ImageInfo, CoverImageInfo, IngressImageInfo?
                const src = this.$helpers.getFullscreenImageSrc(item, imageInfo);
                if (src) {

                    let w;
                    let h;

                    if (imageInfo && imageInfo.Width && imageInfo.Height) {
                        w = imageInfo.Width;
                        h = imageInfo.Height;
                    }
                    // Width and Height could be in item root, as is for FeatureArticle ImagePart  (Type: "File")
                    else if (item && item.Width && item.Height) {
                        w = item.Width;
                        h = item.Height;
                    }

                    // use defaults
                    if (!w || !h) {
                        console.info("Width and height not detected, using defaults - image might appear distorted");
                        w = 1800;
                        h = 1350;
                    }

                    return {
                        src: src,
                        w,
                        h,
                        title: item.Caption || item.title || this.getArtworkTitle(item, true) // from EntityMixin
                    };
                }
            }));
        },

        update: function () {
            if (this.active) {
                this.openSwipe();
            }
            else {
                this.closeSwipe();
            }
        }
    }
};
</script>

<style scoped lang="scss">
// @import '~assets/styles/mixins';

.slideshow {
    z-index: 15000;
}
</style>
